/** 混合图 柱-线 */

import React from 'react';
import { DualAxes } from '@ant-design/charts';
import WidgetEchartConfig from './WidgetEchartConfig';

class WidgetEcharDualAxes extends React.Component
{
    constructor()
    {
        super();

        this.onEvent = this.onEvent.bind(this);
        this.buildConfig = this.buildConfig.bind(this);
    }

    /** event */
    onEvent(chart, event) 
    {
        if( this.props.onEvent!==undefined )
        {
            if( event.type==="element:mousedown" )
            {
                this.props.onEvent( event, event.data.data );
            } 
        } 
    }

    /** create config */
    buildConfig(option, data)
    {
        let yField = [];

        if( option.yField!==undefined)
        {
            for(let i in option.yField )
            {
                yField.push(option.yField[i].name)
            }
        }
        else
        {
            yField.push(...['value', 'value']);
        }
       
        const leftconfig = yField[0];
        const rightconfig = yField[1];

        //配置左右坐标轴数字大小（分明用左右左边轴名称来匹配）
        var yAxis = {};
        yAxis[leftconfig] = {
            label: 
            {
                style:
                {
                fontSize: 16,
                fill: '#333333',
                },
            },
          colorMapping: false,
        };

        yAxis[rightconfig] = {
            label: 
            {
                style:
                {
                fontSize: 16,
                fill: '#333333',
                },
            },
          colorMapping: false,
        };

        let config = {
            data : [data.data, data.data],    //前面为柱形图数据
            xField : option.xField!==undefined ? option.xField.name : 'name',
            yField : yField,  // array
            yAxis: yAxis

        };

        if( option.theme!==undefined )
        {
            config = {...WidgetEchartConfig.theme[option.theme].dualAxesConfig, ...option, ...config};
        }
        else
        {
            config = {...WidgetEchartConfig.theme["default"].dualAxesConfig, ...option, ...config};
        }

        return config;
        
    }

    render()
    {
        const { option, data } = this.props; 
        
        let config = this.buildConfig(option, data);

        return <DualAxes {...config} onEvent={this.onEvent}/>;
    }
}

export default WidgetEcharDualAxes;